var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.218 1.164a.802.802 0 0 1 .8-.8h6.4a.8.8 0 1 1 0 1.6h-6.4a.802.802 0 0 1-.8-.8zm14.4 12.8a10.403 10.403 0 0 1-10.4 10.4 10.402 10.402 0 0 1-10.4-10.4 10.402 10.402 0 0 1 10.4-10.4 10.412 10.412 0 0 1 10.4 10.4zM15.73 8.548a.808.808 0 0 0-1.128.104l-4 4.8a.807.807 0 0 0 .104 1.128.817.817 0 0 0 .512.184.794.794 0 0 0 .616-.288l4-4.8a.807.807 0 0 0-.104-1.128z",
    fill: "#F1D131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.32d5a16a9483b8988acb7b949826089c.svg";
export { ForwardRef as ReactComponent };